/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S10_Li3_DescInputs */

const tr_iade_iptal_s10_li3_desc = /** @type {(inputs: Iade_Iptal_S10_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura ve e-Arşiv kopyaları (QNB eSolutions tarafından oluşturulmuş orijinal halleriyle).`)
};

const en_iade_iptal_s10_li3_desc = /** @type {(inputs: Iade_Iptal_S10_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copies of e-Fatura and e-Arşiv (in the original form created by QNB eSolutions).`)
};

const de_iade_iptal_s10_li3_desc = /** @type {(inputs: Iade_Iptal_S10_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopien von e-Fatura und e-Arşiv (in der von QNB eSolutions erstellten Originalform).`)
};

const ru_iade_iptal_s10_li3_desc = /** @type {(inputs: Iade_Iptal_S10_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копии e-Fatura и e-Arşiv (в оригинальном виде, созданном QNB eSolutions).`)
};

/**
* | output |
* | --- |
* | "Copies of e-Fatura and e-Arşiv (in the original form created by QNB eSolutions)." |
*
* @param {Iade_Iptal_S10_Li3_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s10_li3_desc = /** @type {((inputs?: Iade_Iptal_S10_Li3_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S10_Li3_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s10_li3_desc(inputs)
	if (locale === "de") return de_iade_iptal_s10_li3_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s10_li3_desc(inputs)
	return tr_iade_iptal_s10_li3_desc(inputs)
});